import React, { useState, useCallback, useRef } from 'react'
import { Button, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { NoticeLoading } from '@fs/zion-icon'
import { useQuery } from '@apollo/client'

export function SeeMoreButton({ getMore }) {
  const [t] = useTranslation()
  const [loading, setLoading] = useState(false)

  const onClick = useCallback(() => {
    setLoading(true)
    getMore()
      .then(() => setLoading(false))
      .catch(() => setLoading(false))
  }, [setLoading, getMore])

  return getMore ? (
    <>
      <Separator size="md" />
      <div style={{ textAlign: 'center' }}>
        <Button onClick={onClick} emphasis="medium" Icon={loading ? NoticeLoading : undefined} disabled={loading}>
          {t('search.see-more.label', 'See More')}
        </Button>
      </div>
    </>
  ) : null
}

// Apollo is suppose to have this baked in, but I used their API with the same problem
// everyone is having in this GH issue: https://github.com/apollographql/apollo-client/issues/2499
// So I thought it would be quicker to build our own
export function usePaginatedQuery(query, merge) {
  const pageRef = useRef(1)
  const results = useQuery(query)

  const nextPage = results && results.data && Object.entries(results.data).some(([, data]) => data.nextPage)

  // handle pagination
  const getMore =
    nextPage &&
    (() =>
      results
        .fetchMore({
          variables: { page: pageRef.current + 1 },
          updateQuery: (previousResult, { fetchMoreResult }) => merge(previousResult, fetchMoreResult),
        })
        .then(() => pageRef.current++))

  return {
    ...results,
    getMore,
  }
}
